import { Fragment } from "react";
import backendUrl from "../../../utilities/backendUrl";
import style from "./ShipmentInformation.module.css";

function ShipmentInformation({ parts = [] }) {
  if (parts.length === 0) return <Fragment></Fragment>;

  return (
    <Fragment>
      {parts.map((item, idx) => (
        <div key={idx} className={"my-4 " + style.item}>
          <div className={"bg-avaex text-white " + style.header}>
            <span>اطلاعات</span>
          </div>
          <div className="my-3 px-2">
            <p>
              <span>شماره پارت: </span>
              <span>{item.partnumber}</span>
            </p>
            <p>
              <span>بسته بندی: </span>
              <span>{item.packaging} </span>

              <span className="me-3">محتویات: </span>
              <span>{item.shipment}</span>
            </p>
          </div>

          <div className={style.imgGrid}>
            <h6>تصاویر:</h6>
            <div className={style.imgBox}>
              {item.files.map((item, idx) => (
                <img
                  className={style.img}
                  key={idx}
                  src={backendUrl + "/" + item.path}
                />
              ))}
            </div>
          </div>
        </div>
      ))}
    </Fragment>
  );
}

export default ShipmentInformation;
